import { LINK_WEBSITE } from 'shared/constants/links'

export const getPoweredBySalesmsgLink = (organizationId: number | null) =>
  `${LINK_WEBSITE}/?utm_source=review&utm_medium=product&utm_campaign=review_widget&utm_term=${
    organizationId ?? ''
  }`
